import { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar.js';
import { Topbar } from './components/Topbar.js';
import { Placeholder } from './components/Placeholder.js';
import { Deals } from './pages/Deals.js';
import { NewDeal } from './pages/NewDeal.js';
import { DealDetail } from './pages/DealDetail.js';
import { MyTasks } from './pages/MyTasks.js';
import { Research } from './pages/Research.js';
import { Calibration } from './pages/Calibration.js';
import { Peers } from './pages/Peers.js';
import { Settings } from './pages/Settings.js';
import { Portfolio } from './pages/Portfolio.js';
import { Intake } from './pages/Intake.js';
import { CallsInbox } from './pages/CallsInbox.js';
import { Analytics } from './pages/Analytics.js';
import { Activity } from './pages/Activity.js';
import { Archive } from './pages/Archive.js';

export function App() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();
  // Close the mobile drawer whenever the route changes.
  useEffect(() => { setNavOpen(false); }, [location.pathname]);
  return (
    <div className="flex min-h-screen">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onMenu={() => setNavOpen(true)} />
        <div className="p-4 sm:p-6 max-w-[1600px] w-full">
          <Routes>
            <Route path="/" element={<Navigate to="/deals" replace />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/deals/new" element={<NewDeal />} />
            <Route path="/deals/:id" element={<DealDetail />} />
            <Route path="/tasks" element={<MyTasks />} />
            <Route path="/research" element={<Research />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/calls" element={<CallsInbox />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/activity" element={<Activity />} />
            {/* Admin-only in practice — the page itself checks the role, and the API 403s anyway. */}
            <Route path="/archive" element={<Archive />} />
            <Route path="/calibration" element={<Calibration />} />
            <Route path="/peers" element={<Peers />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Placeholder crumb="" title="Not found" phase="—" />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
